import React from 'react';
import './generation_loader.css';
import { checkGeneratedFiles } from '../../manager/apiManager'
import {
  withRouter
} from 'react-router-dom';

class Progressbar extends React.Component{
    constructor(props){
      super(props);
      const  { id, name } = this.props.match.params
      this.uniqid = id
      this.state = {
        progress: 0,
        speed: 1,
        step: 0,
        color: "#3392FF"
      }
       this.downloadUrl = `${process.env.REACT_APP_REDIRECTED_URL}/contrats/${name}/${this.uniqid}/telechargement`
       this.time = 150 //  = 15s
    }

    componentDidMount() {
        this.interval = setInterval(() => this.frame(), this.time);
        const pullResults = setInterval(() => {
          checkGeneratedFiles(this.uniqid)
          .then(res => {
            if(res.status === 204)
            {
              window.location.href = this.downloadUrl;
            }
          })
        }, 2000)
    }


    frame() {
        if (this.state.progress < 100){
          this.setState((prevState) => ({
            progress: prevState.progress + this.state.speed < 100 ? prevState.progress + this.state.speed : 100 ,
          }));
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidUpdate(prevProps, prevState) {
      // console.log(prevState)
      if (prevState.progress + this.state.speed  ===  100)
      {
        // Call to backend api
        checkGeneratedFiles(this.uniqid)
        .then(res => {
          if(res.status === 204)
          {
            window.location.href = this.downloadUrl;
          }
          else{
            this.setState({progress : 0})
          }
        })
        .catch(() => {
          this.setState({progress : 0})
        })

        this.setState((prevState) => ({
          step: prevState.step + 1,
        }), () => {
          if (this.state.step === 5)
            window.location.href = this.downloadUrl;
        });

      }
    }

    render(){
      return (
        <div className="bar">
        <div id="myBar" style={{
            width: this.state.progress + "%",
            backgroundColor: this.state.color,
          }}>
           <div id="progressText">{this.state.progress}%</div>
        </div>
        </div>
        );
    }
  }

  export default withRouter(Progressbar);




// WEBPACK FOOTER //
// ./src/components/generation_loader/progress_bar.js